export interface APIError {
  status: number;
  message: string;
  originalError?: string;
}

export class APIErrorException extends Error implements APIError {
  public status: number;
  public originalError?: string;

  constructor(status: number, message: string, originalError?: string) {
    super(message);
    this.name = "APIErrorException";
    this.status = status;
    this.originalError = originalError;
  }
}

export class NetworkErrorException extends Error {
  constructor(message = "Erro de rede") {
    super(message);
    this.name = "NetworkErrorException";
  }
}

export class TimeoutErrorException extends Error {
  constructor(message = "Timeout da operação") {
    super(message);
    this.name = "TimeoutErrorException";
  }
}

export function isAPIError(error: unknown): error is APIError {
  return (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    "message" in error &&
    typeof (error as Record<string, unknown>).status === "number"
  );
}

export function isNetworkError(error: unknown): error is NetworkErrorException {
  return error instanceof NetworkErrorException;
}

export function isTimeoutError(error: unknown): error is TimeoutErrorException {
  return error instanceof TimeoutErrorException;
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (isAPIError(error)) return error.message;
  return String(error);
}

export function getErrorDetails(error: unknown): Record<string, unknown> {
  if (error instanceof Error) {
    return { name: error.name, message: error.message, stack: error.stack };
  }
  if (isAPIError(error)) {
    return { status: error.status, message: error.message, originalError: error.originalError };
  }
  return { value: error, type: typeof error };
}
